module.exports = __webpack_public_path__ + "img/offersHeart.435fb72b.png";